import { Navigate } from "react-router-dom";
import { useRoles } from "../lib/auth";
import Loading from "../Loading";
import DocsLayout from "./DocsLayout";

export default function AdminDocsRoute() {
  const roles = useRoles();

  // Still loading roles
  if (roles.length === 0) {
    return <Loading />;
  }

  // Not an admin - redirect to dashboard
  if (!roles.includes("Admin")) {
    return <Navigate to="/dashboard" replace />;
  }

  return <DocsLayout />;
}
